import { zodResolver } from "@mantine/form";
import { smsReminderNotificationTemplateDataSchema } from "beitary-shared";
import { z } from "zod";

const smsTemplateFormSchema = smsReminderNotificationTemplateDataSchema;

export type SMSTemplateFormValues = z.infer<typeof smsTemplateFormSchema>;

export const rules = zodResolver(smsTemplateFormSchema);
